import { DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as $ from "jquery";
import * as _ from "lodash";
import { BsModalRef } from "ngx-bootstrap/modal";
import swal from "sweetalert2";
import * as fromRootStore from "../../../reducers";
import { Combo2Service } from "../../../services/index";
//import {AddEditPurchaseOrder} from '../../addEditPurchaseOrder';
import { PurchaseOrderService } from "../../../services/purchaseorder.service";
import { SalesOrderService } from "../../../services";
import { PrintData } from "../../master/print/print";
declare var google;

@Component({
  selector: "purchaseReturn",
  host: { "(window:keydown)": "hotkeys($event)" },
  templateUrl: "./pdcList.html"
})
export class pdcList implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input("params") params: any;
  @Input() active = false;
  @Input() dataContext;
  @Output() tabUpdateEvent = new EventEmitter();

  seasonList = [];
  gridOptions: any;
  dataList = [];
  temp_row = [];
  isLoadMask: Promise<any>;
  selectedDlrMapList: any[];
  bsModalRef: BsModalRef;
  loadingIndicator: boolean = true;
  cour_det_id: "";
  reorderable: boolean = true;

  partyTypeList = ["CHEQUE PASS", "CHEQUE RETURN"];
  filter = {
    party_name: "",
    chq_date: "",
    chq_no: ""
  };
  page = {
    limit: 25,
    count: 0,
    offset: 0,
    orderBy: "party_name",
    orderDir: "asc"
  };
  pdcData = {
    chq_status: ""
  }
  finyearList = [];
  agentList = [];
  seasonfinList = [];
  partyAgentList = [];
  partyList = [];
  printData;

  @ViewChild("snoTemplate") snoTemplate: TemplateRef<any>;
  @ViewChild("nameTemplate") nameTemplate: TemplateRef<any>;
  @ViewChild("addrTemplate") addrTemplate: TemplateRef<any>;
  @ViewChild("editDeleteTemplate") editDeleteTemplate: TemplateRef<any>;
  @ViewChild("verifyTemplate") verifyTemplate: TemplateRef<any>;
  @ViewChild("DepositTemplate") DepositTemplate: TemplateRef<any>;


  @ViewChild("filterPanel") filterPanel;
  @ViewChild("partyDataTable") partyDataTable;
  @ViewChild("invoiceReturnTemplate") invoiceReturnTemplate: TemplateRef<any>;

  finyearCtrl: FormControl = new FormControl();
  seasonCtrl: FormControl = new FormControl();
  agentCtrl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  groupCtrl: FormControl = new FormControl();
  columns = [];
  toggleCol = [];
  menu: any;
  reportName = "design_no";
  reportType = "Design";
  filterExpand = false;
  filterData: any;
  agentList$ = [];
  user: any;
  agentVisible: boolean = false;
  companyInfo: any = [];
  returnList: any = [];
  constructor(
    public store: Store<fromRootStore.State>,
    private returnservice: SalesOrderService,
    public datePipe: DatePipe,
    private combo2Service: Combo2Service,
    // private modalService: BsModalService,
    public toasterService: ToasterService,
    private poservice: PurchaseOrderService
  ) { }

  ngOnInit(): void {
    this.getColumns();
    this.toggleCol = Object.assign({}, this.columns);
  }

  hotkeys(event) {
    if (this.active) {
    }
  }

  getColumns() {
    this.columns = [
      {
        name: "SNo",
        prop: "sno",
        minWidth: 80,
        maxWidth: 80,
        width: 80,
        headerClass: "text-center",
        sortable: false,
        cellTemplate: this.snoTemplate,
        toggle: true,
        cellClass: "text-center"
      },
      {
        name: "Party Name",
        prop: "party_code",
        cellClass: "text-leftt",
        headerClass: "text-left",
        minWidth: 140,
        maxWidth: 140,
        width: 140
      },
      {
        name: "Cheque/DD No",
        prop: "chq_no",
        cellClass: "text-right",
        headerClass: "text-right",
        minWidth: 140,
        maxWidth: 140,
        width: 140
      },
      {
        name: "Cheque/DD Date",
        prop: "chq_formatted",
        cellClass: "text-center",
        headerClass: "text-center",
        minWidth: 160,
        maxWidth: 160,
        width: 160
      },
      {
        name: "Payment Type",
        prop: "payment_type",
        cellClass: "text-center",
        headerClass: "text-center",
        minWidth: 200,
        maxWidth: 200,
        width: 200
      },
      {
        name: "Bank Name",
        prop: "bank_name",
        cellClass: "text-center",
        headerClass: "text-center",
        minWidth: 160,
        maxWidth: 160,
        width: 160
      },
      {
        name: "Amount",
        prop: "amount",
        cellClass: "text-right",
        headerClass: "text-right",
        minWidth: 130,
        maxWidth: 130,
        width: 130
      },

      // {
      //   name: "Action",
      //   prop: "sno",
      //   headerClass: "text-center",
      //   minWidth: 170,
      //   maxWidth: 170,
      //   width: 170,
      //   sortable: false,
      //   cellTemplate: this.editDeleteTemplate
      // },
      // {
      //   name: "print",
      //   prop: "sno",
      //   minWidth: 60,
      //   maxWidth: 60,
      //   width: 60,
      //   cellClass: "text-center",
      //   sortable: false,
      //   cellTemplate: this.invoiceReturnTemplate
      // },
      {
        name: "Deposit Details",
        prop: "sno",
        minWidth: 130,
        maxWidth: 130,
        width: 130,
        cellClass: "text-center",
        sortable: false,
        cellTemplate: this.verifyTemplate,
      },
      {
        name: "Cheque Status",
        prop: "sno",
        minWidth: 180,
        maxWidth: 180,
        width: 180,
        cellClass: "text-center",
        sortable: false,
        cellTemplate: this.DepositTemplate,
      },
    ];
    this.toggleCol = Object.assign({}, this.columns);
    this.getReturnList();
    this.pageCallback({ offset: 0 });
  }

  onOpenedFilter(): void {
    setTimeout(function () {
      $("#party_name").focus();
    }, 100);
  }

  onChangePageSize(limit) {
    this.page.limit = 10000;
    //this.getSalesinvReport();
  }

  onColumnToggle(colToShow) {
    this.columns = colToShow;
  }

  onEnterKeyPressed(nextEl: string, ind, item) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      $("#" + nextEl).focus();
    }
  }

  getRowClass(event) {
    return event.rowtype == "summary" ? "summary-row" : "";
  }

  /**
   * Called whenever the user changes page
   */
  pageCallback(pageInfo: {
    count?: number;
    pageSize?: number;
    limit?: number;
    offset?: number;
  }) {
    this.page.offset = pageInfo.offset;
  }

  /**
   * Called whenever the user changes the sort order
   */
  sortCallback(sortInfo: {
    sorts: { dir: string; prop: string }[];
    column: {};
    prevValue: string;
    newValue: string;
  }) {
    // there will always be one "sort" object if "sortType" is set to "single"
    this.page.orderDir = sortInfo.sorts[0].dir;
    this.page.orderBy = sortInfo.sorts[0].prop;
    // this.getSalesinvReport();
  }

  clearFilter(): void {
    this.filter.party_name = "";
    // this.filter.po_no='';
    this.filter.chq_date = "";
    this.filter.chq_no = "";
    this.applyFilter();
  }

  applyFilter(): void {
    //this.filterExpand = false;
    this.filterPanel.close();
    this.getReturnList();
  }
  addDepositdet(row) {
    this.cour_det_id = row.cour_det_id;

  }
  addchqstatedet(row) {
    this.temp_row = row;
    this.cour_det_id = row.cour_det_id;

  }
  loadSeasonList() {
    let that = this;
    this.combo2Service.seasonCombo().then(function (res) {
      //  this.LoadAgentList();
      that.seasonList = res.data;
      that.seasonCtrl.setValue(res.data[0].season_id);
    });
  }
  saveModal() {
    var bank = document.getElementById("bank_name") as HTMLInputElement;
    var bank_name = bank.value;
    var dep_date = document.getElementById("deposit_date") as HTMLInputElement;
    var deposit_date = dep_date.value;
    let params = {
      cour_det_id: this.cour_det_id,
      bank_name: bank_name,
      deposit_date: deposit_date
    };
    let that = this;
    this.returnservice.updatedepositDet(params).then(function (res: any) {
      that.getReturnList();
    });

    dep_date.value = "";
    bank.value = "";

  }
  addDate(){
    var pass_date = document.getElementById("pass_date") as HTMLInputElement;
    var pas_date = pass_date.value;
    var rec_date = document.getElementById("rec_date") as HTMLInputElement;
    rec_date.value = pas_date
    }
  savechqStatus() {
    let temp_mode = "";
    let params = new Object();
    if (this.pdcData.chq_status == 'CHEQUE PASS') {
      var pass_date = document.getElementById("pass_date") as HTMLInputElement;
      var pas_date = pass_date.value;
      var rec_date = document.getElementById("rec_date") as HTMLInputElement;
      var re_date = rec_date.value;
      params = {
        type: this.pdcData.chq_status,
        cour_det_id: this.cour_det_id,
        re_date: re_date,
        pas_date: pas_date
      };
      let that = this;
      this.returnservice.updatepassDet(params).then(function (res: any) {

        // that.bsModalRef.hide();
        let row = that.temp_row
        // console.log(that.temp_row)
          that.temp_row["rec_date"] = re_date;
        let tabObj = {
          action: "NewTab",
          params: {
            //   tabParent: 'Transaction',
            tabName: "ADD PAYMENT VOUCHER",
            title: "ADD PAYMENT VOUCHER",
            tabParent: "SALES_PLAN",
            mode: 'PDC_Add',
            data: that.temp_row,
            name: "VIEW PAYMENT VOUCHER",
          },
        };

        that.getReturnList();
        that.tabUpdateEvent.emit(tabObj);
        pass_date.value = "";
        rec_date.value = "";
        that.temp_row = [];
      });

    }
    else if (this.pdcData.chq_status == 'CHEQUE RETURN') {
      var return_date = document.getElementById("return_date") as HTMLInputElement;
      var ret_date = return_date.value;
      var reason = document.getElementById("reason") as HTMLInputElement;
      var rea_son = reason.value;
      var chq_det = document.getElementById("chq_det") as HTMLInputElement;
      var detuction = chq_det.value;
      params = {
        type: this.pdcData.chq_status,
        cour_det_id: this.cour_det_id,
        ret_date: ret_date,
        rea_son: rea_son,
        detuction: detuction
      };
      let that = this;
      this.returnservice.updatepassDet(params).then(function (res: any) {
        let row = that.temp_row
        that.temp_row["ref_date"] = ret_date;
        that.temp_row["mode"] = 'CHEQUE RETURN'
        that.temp_row["pay_id"] = 0;

        that.returnservice.chequeReturnDetails(that.temp_row).then(function (res: any) {
          that.getReturnList();
          reason.value = "";
          chq_det.value = "";
          return_date.value = "";
          that.temp_row = [];
        });
      });

    }




  }
  // closeModal() {
  //   var verifiedby1 = document.getElementById("verifiedby") as HTMLInputElement;
  //   this.inv_no = "";
  //   this.dcid = "";
  //   verifiedby1.value = "";
  // }
  addEditReturn(mode: string, row: any): void {
    let listUpdateEvent = new EventEmitter();
    listUpdateEvent.subscribe(() => {
      this.getReturnList();
    });
    row.tabevent = listUpdateEvent;
    let tabObj = {};
    if (mode == "Add") {
      tabObj = {
        action: "NewTab",
        params: {
          //  tabParent: 'Transaction',
          tabName: "ADD PURCHASE RETURN",
          title: "ADD PURCHASE RETURN",
          tabParent: "CLOTH",
          mode: mode,
          data: row,
          name: "AddEditPurchaseReturn"
        }
      };
    } else if (mode == 'Edit') {
      tabObj = {
        action: "NewTab",
        params: {
          //   tabParent: 'Transaction',
          tabName: "EDIT PURCHASE RETURN",
          title: "EDIT PURCHASE RETURN",
          tabParent: "CLOTH",
          mode: mode,
          data: row,
          name: "AddEditPurchaseReturn"
        }
      };
    } else if (mode == 'View') {
      tabObj = {
        action: "NewTab",
        params: {
          //   tabParent: 'Transaction',
          tabName: "VIEW PURCHASE RETURN",
          title: "VIEW PURCHASE RETURN",
          tabParent: "CLOTH",
          mode: mode,
          data: row,
          name: "AddEditPurchaseReturn"
        }
      };
    }

    this.tabUpdateEvent.emit(tabObj);
  }
  // printInvoiceRet(row) {
  //   delete row.tabevent;
  //   let params = {
  //     printType: "purchaseInvoiceReturn",
  //     data : JSON.stringify(row)
  //   };
  //   this.returnservice.purchaseInvoiceReturnPrint(params).then((res: any) => {
  //     this.printData = res;

  //     this.bsModalRef = this.modalService.show(PrintData, {
  //       keyboard: false,
  //       ignoreBackdropClick: true,
  //       class: "compWidth-70"
  //     });
  //     this.bsModalRef.content.stkdata = Object.assign({}, row);
  //     this.bsModalRef.content.printcontent = this.printData;
  //   });
  // }
  getReturnList(): void {
    if (this.filter.chq_date == "") {
      this.filter.chq_date == "";
    } else {
      this.filter.chq_date = this.datePipe.transform(
        this.filter.chq_date,
        "yyyy-MM-dd"
      );
    }
  
    //this.filter.order_to_date = this.datePipe.transform(this.filter.order_to_date, 'yyyy-MM-dd');
    let params = {
      start: `${this.page.offset * (this.page.limit + 1)}`,
      limit: `${this.page.limit}`,
      page: "1",
      orderColumn: `${this.page.orderBy}`,
      orderDir: `${this.page.orderDir}`,
      party_name: this.filter.party_name,
      //po_no:this.filter.po_no,
      chq_date: this.filter.chq_date,
      chq_no: this.filter.chq_no
    };
    let that = this;
    //this.store.dispatch(new commonActions.LoadAllParty(params));
    this.isLoadMask = this.returnservice
      .getPDCList(params)
      .then(function (res: any) {
        that.loadingIndicator = false;
        that.page.count = res.totCnt;
        that.returnList = res.data;
      });
  }

  deleteOrder(row: any): void {
    let that = this;
    swal({
      title: "Are you sure to delete this Order Details?",
      text:
        "You will not be able to recover this Order" + " " + row["po_no"] + "",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, keep it"
    }).then(
      function () {
        that.isLoadMask = that.poservice
          .deleteOrder(row)
          .then(function (res: any) {
            that.loadingIndicator = false;
            that.getReturnList();
            let errtype = "success",
              errmsg = res.message;
            if (!res.success) {
              errtype = "error";
            }

            that.toasterService.pop({
              bodyOutputType: 1,
              type: errtype,
              title: errtype.toUpperCase(),
              body: errmsg
            });
          });
      },
      function (dismiss) { }
    );
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Sales/courier/pdcList.ts